<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="编辑报验记录" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-cell-group>
				<van-field readonly clickable :value="subjectMatter" name="subjectMatter" label="标的物" placeholder="请选择标的物"
					:rules="[{ required: true, message: '' }]" @click="showSubjectMatterPicker = true" />
				<van-popup v-model="showSubjectMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="subjectMatterList" value-key="displayName"
						@confirm="selSubjectMatter" @cancel="showSubjectMatterPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="major" name="major" label="专业" placeholder="请选择专业"
					:rules="[{ required: true, message: '' }]" @click="showMajorPicker = true" />
				<van-popup v-model="showMajorPicker" position="bottom">
					<van-picker show-toolbar :columns="majorList" value-key="displayName" @confirm="selMajorPicker"
						@cancel="showMajorPicker = false" />
				</van-popup>
				<van-field :value="recSortCode" v-model="recSortCode" name="recSortCode" label="序号" />
				<!-- <van-field readonly clickable
					:value="category"
					name="category" 
					label="范畴" 
					placeholder="请选择范畴"
					:rules="[{ required: true, message: '' }]"
					@click="showCategoryPicker = true" />
				<van-popup v-model="showCategoryPicker" position="bottom">
					<van-picker show-toolbar :columns="categoryList" value-key="name" @confirm="selCategoryPicker" @cancel="showCategoryPicker = false" />
				</van-popup> -->
				<!-- <van-field readonly clickable
					:value="checkTypeName"
					name="checkTypeName" 
					label="检验形式" 
					placeholder="请选择检验形式"
					:rules="[{ required: true, message: '' }]"
					@click="showCheckTypePicker = true" />
				<van-popup v-model="showCheckTypePicker" position="bottom">
					<van-picker show-toolbar :columns="checkTypeList" value-key="displayName" @confirm="selCheckTypePicker" @cancel="showCheckTypePicker = false" />
				</van-popup>
				<van-field
					v-model="parts"
					name="parts"
					label="部件"
					placeholder="请输入部件"
				/> -->
				<van-field readonly clickable :value="date" name="date" label="检验时间" placeholder="请选择检验时间"
					:rules="[{ required: true, message: '' }]" @click="showDateCalendar = true" />
				<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selDateCalendar" />
				<van-field class="textareaField" v-model="content" type="textarea" name="content" label="检验项目"
					placeholder="请输入检验项目" :rules="[{ required: true, message: '' }]" />
				<van-field v-model="userName" name="userName" label="检验人" placeholder="请输入检验人"
					:rules="[{ required: true, message: '' }]" />
				<van-field readonly clickable :value="conclusion" name="conclusion" label="检验结论" placeholder="请选择1次检验结论"
					@click="showConclusionPicker = true && codeFlg == '1'" />
				<van-popup v-model="showConclusionPicker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusionPicker" @cancel="showConclusionPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="conclusion2" name="conclusion2" label="2次检验结论" placeholder="请选择2次检验结论"
					@click="showConclusion2Picker = true && codeFlg == '2'" />
				<van-popup v-model="showConclusion2Picker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusion2Picker" @cancel="showConclusion2Picker = false" />
				</van-popup>
				<van-field readonly clickable :value="conclusion3" name="conclusion3" label="2次以上结论"
					placeholder="请选择2次以上检验结论" @click="showConclusion3Picker = true && codeFlg == '3'" />
				<van-popup v-model="showConclusion3Picker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusion3Picker" @cancel="showConclusion3Picker = false" />
				</van-popup>
				<van-field class="textareaField" v-model="sutContent" type="textarea" name="sutContent" label="检验意见"
					placeholder="请输入检验意见" :rules="[{ required: true, message: '' }]" />
				<van-field class="textareaField" v-model="remark" type="textarea" name="remark" label="备注"
					placeholder="请输入备注" />
				<van-field v-model="closeMan" name="closeMan" label="封闭人" placeholder="请输入封闭人" />
				<van-field readonly clickable :value="closeTime" name="closeTime" label="封闭时间" placeholder="请选择封闭时间"
					@click="showCloseTimeCalendar = true" />
				<van-calendar v-model="showCloseTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selCloseTimeCalendar" />
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="scenePhotoList" label="整改前照片">
						<template #input>
							<van-uploader v-model="scenePhotoList" :after-read="uploadBeforePhoto"
								:before-delete="beforePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="closePhotoList" label="整改后照片">
						<template #input>
							<van-uploader v-model="closePhotoList" :after-read="uploadClosePhoto"
								:before-delete="closePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
				<!-- <van-field
					class="uploaderField"
					name="fileList" label="现场照片">
					<template #input>
						<van-uploader v-model="fileList" :after-read="uploadFile" 
						:before-delete="beforeDelete"
						accept="image/*"
						/>
					</template>
				</van-field> -->
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>

	</div>
</template>
<script>
import { info, updateTestRecord } from '../../api/safeInspection'
import { upload, getInspectionConclusion, getProblemImportant, getMajorList, getTestItemTestType, getSubjectDropDown } from '../../api/commonApi'
import { Notify } from 'vant';
import ImageCompressor from '@/utils/ImageCompressor'
import common from '../../utils/common';

export default {
	name: 'safeInspectionEdit',
	data() {
		return {
			id: "",
			testId: "",
			subjectMatter: "",
			subjectMatterId: "",
			showSubjectMatterPicker: false,
			// 模拟数据
			subjectMatterList: [
			],
			major: "",
			majorId: "",
			showMajorPicker: false,
			showCloseTimeCalendar: false,
			// 模拟数据
			majorList: [
			],
			category: "",
			categoryId: "",
			showCategoryPicker: false,
			categoryList: [
				// 待拆分为质量和安全两个画面。质量：1 ； 安全：2； 进度：3
				{ id: 1, name: "质量" }
			],
			checkTypeName: "",
			checkTypeId: "",
			showCheckTypePicker: false,
			checkTypeList: [
			],
			parts: "",
			date: "",
			showDateCalendar: false,
			content: "",
			// 画面中的项目：检验意见
			sutContent: "",
			recSortCode: '',
			// 备注
			remark: "",
			conclusion: "",
			conclusionId: "",
			conclusion2: "",
			conclusionId2: "",
			conclusion3: "",
			conclusionId3: "",
			showConclusionPicker: false,
			showConclusion2Picker: false,
			showConclusion3Picker: false,
			codeFlg: "",
			// 模拟数据
			conclusionList: [
			],
			important: "",
			importantId: "",
			showImportantPicker: false,
			// 模拟数据
			importantList: [
			],
			// 检验人
			userName: "",
			fileList: [],
			param: {},
			minDate: new Date(new Date().getFullYear() - 2, 0, 1, 0, 0, 0),
			maxDate: new Date(new Date().getFullYear() + 2, 11, 31, 23, 59, 59),
			addPhotoList: [],
			addScenePhotoList: [],
			scenePhotoList: [],
			addCloseFileList: [],
			closeFileList: [],
			addClosePhotoList: [],
			closePhotoList: [],
			closeTime: "",
			closeMan: "",
			businessType: "10", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
			fileKey: "0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined || !this.project.workNo) {
			Notify({ type: 'danger', message: '获取工作控制号失败' });
		}
		this.id = this.$route.query.id;
		this.doGetTestItemTestType()
		this.doGetInspectionConclusion()
		this.doGetProblemImportant()
		this.doGetSubjectDropDown()
		this.doGetMajorList()
		this.getInfo(this.id)
	},
	methods: {
		getInfo(id) {
			info(id).then(response => {
				if (response.data.resultCode != 200) {
					Notify({ type: 'danger', message: response.data.resultMessage });
					return
				}
				const data = response.data.body
				this.param = data
				// 回显
				this.subjectMatterId = data.subjectNo;
				if (this.subjectMatterList.length > 0) {
					this.subjectMatterList.forEach(item => {
						if (item.displayValue == this.subjectMatterId) {
							this.subjectMatter = item.displayName
						}
					})
				}
				this.testId = data.testId;
				this.major = data.majorName;
				this.majorId = data.major;
				this.category = data.categoryName
				this.categoryId = data.category
				this.checkTypeName = data.testTypeName;
				this.checkTypeId = data.testType;
				this.parts = data.partsName
				this.date = data.testDate
				// 检验内容
				this.content = data.probContext
				this.userName = data.testMan
				this.conclusion = data.testConclusionName
				this.conclusionId = data.testConclusion
				this.conclusion2 = data.testConclusionName2
				this.conclusionId2 = data.testConclusion2
				this.conclusion3 = data.testConclusionName3
				this.conclusionId3 = data.testConclusion3
				this.sutContent = data.sutContent
				this.recSortCode = data.recSortCode
				this.remark = data.remark
				this.importantId = data.iptFlg
				// if(this.importantId) {
				// 	this.importantList.forEach(item => {
				// 		if(this.importantId == item.displayValue) {
				// 			this.important = item.displayName
				// 		}
				// 	})
				// }
				this.closeTime = data.closeTime
				this.closeMan = data.closeMan
				if (data.scenePhotoList) {
					data.scenePhotoList.forEach(item => {
						this.scenePhotoList.push(
							{ url: item.fileUri }
						)
						this.addScenePhotoList.push(item)
					})
				}
				// 整改后图片
				if (data.closePhotoList) {
					data.closePhotoList.forEach(item => {
						this.closePhotoList.push(
							{ url: item.fileUri }
						)
						this.addClosePhotoList.push(item)
					})
				}
				// 封闭文件
				if (data.closeFileList) {
					data.closeFileList.forEach(item => {
						this.closeFileList.push(
							{ url: item.fileUri }
						)
						this.addCloseFileList.push(item)
					})
				}
				this.containCode(this.recSortCode)
			})
		},
		containCode(recSortCode) {
			var sortCode = recSortCode + "";
			var numReg = /^[0-9]+$/
			var numRe = new RegExp(numReg)
			if (numRe.test(sortCode)) {
				this.codeFlg = '1';
			} else if (sortCode.lastIndexOf('A') == sortCode.length - 1) {
				this.codeFlg = '2';
			} else {
				this.codeFlg = '3';
			}
		},
		// 根据标的物查询专业
		doGetMajorList() {
			getMajorList(this.project.workNo).then(response => {
				this.majorList = response.data.body
			})
		},
		// 检验形式
		doGetTestItemTestType() {
			getTestItemTestType().then(response => {
				this.checkTypeList = response.data.body
			})
		},
		// 检验结论
		doGetInspectionConclusion() {
			getInspectionConclusion().then(response => {
				this.conclusionList = response.data.body
			})
		},
		// 重要程度
		doGetProblemImportant() {
			getProblemImportant().then(response => {
				this.importantList = response.data.body
				// 如果getInfo()方法先执行完了，在这里给important赋值。
				if (!this.important) {
					this.importantList.forEach(item => {
						if (this.importantId == item.displayValue) {
							this.important = item.displayName
						}
					})
				}
			})
		},
		// 标的物
		doGetSubjectDropDown() {
			getSubjectDropDown(this.project.workNo).then(response => {
				this.subjectMatterList = response.data.body
				// 如果getInfo()方法先执行完了，在这里给subjectMatter赋值。
				if (!this.subjectMatter) {
					this.subjectMatterList.forEach(item => {
						if (item.displayValue == this.subjectMatterId) {
							this.subjectMatter = item.displayName
						}
					})
				}
			})
		},
		goBack() {
			this.$router.push({
				name: 'safeInspectionList'
			});
		},
		selSubjectMatter(data) {
			this.subjectMatter = data.displayName;
			this.showSubjectMatterPicker = false;
			if (this.subjectMatterId != data.displayValue) {
				this.subjectMatterId = data.displayValue
				// clear major value
				this.major = ""
				this.majorId = ""
			}
		},
		selMajorPicker(data) {
			this.major = data.displayName;
			this.majorId = data.displayValue;
			this.showMajorPicker = false;
		},
		selCategoryPicker(data) {
			this.category = data.name;
			this.categoryId = data.id;
			this.showCategoryPicker = false;
		},
		selCheckTypePicker(data) {
			this.checkTypeName = data.displayName;
			this.checkTypeId = data.displayValue;
			this.showCheckTypePicker = false;
		},
		selConclusionPicker(data) {
			this.conclusion = data.displayName;
			this.conclusionId = data.displayValue;
			this.showConclusionPicker = false;
			if (this.conclusionId == '0') {
				// clear import value
				this.important = '';
				this.importantId = '';
			}
		},
		selConclusion2Picker(data) {
			this.conclusion2 = data.displayName;
			this.conclusionId2 = data.displayValue;
			this.showConclusion2Picker = false;
		},
		selConclusion3Picker(data) {
			this.conclusion3 = data.displayName;
			this.conclusionId3 = data.displayValue;
			this.showConclusion3Picker = false;
		},
		selDateCalendar(date) {
			this.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showDateCalendar = false;
		},
		selCloseTimeCalendar(date) {
			this.closeTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCloseTimeCalendar = false;
		},
		selImportantPicker(data) {
			this.important = data.displayName;
			this.importantId = data.displayValue;
			this.showImportantPicker = false;
		},
		async uploadFile(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();
			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addCloseFileList.push(
						{
							recFileType: '2',
							fileName: this.extractFileName(dataBody.fileName),
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		async uploadClosePhoto(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addClosePhotoList.push(
						{
							recFileType: '1',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		async uploadBeforePhoto(file) {
			console.log(file)
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			console.log(files)
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addScenePhotoList.push(
						{
							recFileType: '0',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
					console.log(this.addScenePhotoList)
				}
			})
		},
		beforeDelete(file, detail) {
			this.fileList.splice(detail.index, 1)
			// 删除照片
			this.addPhotoList.splice(detail.index, 1)
		},
		beforePhotoDelete(file, detail) {
			this.scenePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addScenePhotoList.splice(detail.index, 1)
		},
		closePhotoDelete(file, detail) {
			this.closePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addClosePhotoList.splice(detail.index, 1)
		},
		closeFileDelete(file, detail) {
			this.closeFileList.splice(detail.index, 1)
			// 删除照片
			this.addCloseFileList.splice(detail.index, 1)
		},
		onSubmit(data) {
			if (!common.hasPermision("information:edit:2")) {
				Notify({ type: 'danger', message: "无操作权限" });
				return;
			}
			this.param.testId = this.testId;
			this.param.t = new Date().getTime(),
				this.param.subjectNo = this.subjectMatterId,
				this.param.major = this.majorId,
				// 图片list
				this.param.list = this.addPhotoList,
				this.param.testConclusion = this.conclusionId,
				this.param.testConclusion2 = this.conclusionId2,
				this.param.testConclusion3 = this.conclusionId3,
				this.param.testDate = this.date,
				this.param.testMan = this.userName,
				this.param.partsName = this.parts,
				// 重要程度
				this.param.iptFlg = this.importantId,
				this.param.testType = this.checkTypeId,
				// 检验内容
				this.param.probContext = this.content,
				// 整改意见（PC端实际上传的画面中项目【检验意见】的值）
				this.param.sutContent = this.sutContent,
				this.param.recSortCode = this.recSortCode,
				// 备注
				this.param.remark = this.remark,
				this.param.scenePhotoList = this.addScenePhotoList,
				this.param.closeFileList = this.addCloseFileList,
				this.param.closePhotoList = this.addClosePhotoList,
				this.param.closeTime = this.closeTime,
				this.param.closeMan = this.closeMan
			updateTestRecord(this.param).then(response => {
				if (response.data.resultCode === 200) {
					Notify({ type: 'success', message: '操作成功' });
					this.goBack()
				} else {
					Notify({ type: 'danger', message: response.data.resultMessage });
				}
			})
		},
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>